// Joins the Device tab's unified-timeline ODL / AD events to the Client Debug analyses that used them.
//
// A timeline ODL or AD_LOG event carries `data.artifactId` = odl_merge_jobs.id. The Client Debug service
// records the same id as `sourceId` on every file it sent to an analysis, so matching on it guarantees the
// analysed logs shown are a subset of the timeline's events. Identifiers only: the analysis content is not
// available here by design.

export const MAX_SOURCE_IDS_PER_REQUEST = 500;

const LOG_EVENT_TYPES = ['ODL', 'AD_LOG'];

export function isLogEvent(event) {
  return LOG_EVENT_TYPES.includes(event?.eventType);
}

/** The timeline's artifactId of an ODL / AD_LOG event, as a string; null for any other event. */
export function logArtifactId(event) {
  const id = isLogEvent(event) ? event?.data?.artifactId : null;
  return id === null || id === undefined || id === '' ? null : String(id);
}

/** Distinct artifactIds of the ODL / AD_LOG events, in timeline order. */
export function collectLogSourceIds(events) {
  const ids = new Set();
  (events || []).forEach((event) => {
    const id = logArtifactId(event);
    if (id !== null) ids.add(id);
  });
  return [...ids];
}

export function chunk(items, size) {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

/** { [sourceId]: entries[] } from the analyzed-logs response; newest analysis first as returned. */
export function indexAnalyzedLogs(analyzedLogs) {
  const bySource = {};
  (analyzedLogs || []).forEach((entry) => {
    if (entry?.sourceId === null || entry?.sourceId === undefined) return;
    const key = String(entry.sourceId);
    (bySource[key] = bySource[key] || []).push(entry);
  });
  return bySource;
}

/** One line per analysis: "LogTalk · event evt-1 · job 1a2b3c4d (COMPLETED) · ✉ Email sent". */
export function describeAnalysis(entry) {
  const parts = [entry.analysisName === 'logtalk' ? 'LogTalk' : (entry.analysisName || 'Analysis')];
  if (entry.analysisId) parts.push(`event ${entry.analysisId}`);
  if (entry.jobId) {
    parts.push(`job ${String(entry.jobId).slice(0, 8)}${entry.jobStatus ? ` (${entry.jobStatus})` : ''}`);
  }
  if (entry.emailSent) parts.push('Email sent');
  return parts.join(' · ');
}
